export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-08.33e68f1d.jpg";